// extracted by mini-css-extract-plugin
export default {"navigateBtnCol":"oneWayInterviewConfiguration_navigateBtnCol__+gLBe","dividerLine":"oneWayInterviewConfiguration_dividerLine__HKS6-"};